import React from 'react'
import './CallingDialogue.css'
const CallingDialogue = () => {
  return (
    <div className='direct_call'>
      <p style={{ fontSize: '1.5em' }}>Calling...</p>
    </div>
  )
}

export default CallingDialogue
